export class LandingPageFeedsModel {
    title: string;
    decodedTitle: string;
    link: string;
    author: string;
    date: string;
    category: string;

    constructor(apiFeeds) {
        if (apiFeeds) {
            this.title = apiFeeds.title;
            this.link = apiFeeds.link;
            this.author = apiFeeds['dc:creator'];
            this.date = apiFeeds.pubDate;
            this.category = apiFeeds.category;

            const div = document.createElement('div');
            div.innerHTML = apiFeeds.title;
            this.decodedTitle = div.innerText;
        }
    }
}
